import { BORDER_RADIUS, SPACING, Avatar } from '@community_dev/pixels'
import type { JSX } from 'react'
import styled from 'styled-components'

import { formatPhone } from 'utils/normalize'

export type ClientDetailProps = {
  name: string
  phoneNumber: string
  clientImage?: string
  className?: string
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme?.COLORS?.APP_BACKGROUND_LEVEL_2};
  border-radius: ${BORDER_RADIUS[1]};
  padding: ${SPACING[2]} ${SPACING[4]};
  margin: ${SPACING[5]} 0;
`
const StyledDetails = styled.div`
  flex-grow: 1;
  text-align: left;
  margin-left: ${SPACING[4]};
`

const StyledName = styled.p`
  ${({ theme }) => theme?.TYPOGRAPHY?.VARIANT?.BODY1};
  font-weight: 600;
  margin: 0;
`

const StyledPhone = styled.p`
  color: ${({ theme }) => theme?.COLORS?.SUBTEXT};
  ${({ theme }) => theme?.TYPOGRAPHY?.VARIANT?.CAPTION1};
  font-weight: 500;
  margin: 0;

  span {
    ${({ theme }) => theme?.TYPOGRAPHY?.VARIANT?.CAPTION1};
    font-weight: 600;
    color: ${({ theme }) => theme?.COLORS?.LINKS};
  }
`

export const ClientDetail = ({ name, clientImage, phoneNumber, className }: ClientDetailProps): JSX.Element => (
  <Wrapper className={className}>
    <Avatar name={name} src={clientImage} />
    <StyledDetails>
      <StyledName>{name}</StyledName>
      <StyledPhone>{formatPhone(phoneNumber)}</StyledPhone>
    </StyledDetails>
  </Wrapper>
)
